"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { cn } from "@/lib/utils";
import { DOC_SECTIONS, DOCS_BASE } from "@/app/(marketing)/docs/_config";
import { DocIcon } from "@/components/docs/icons";

export function SidebarNav({ onNavigate }: { onNavigate?: () => void }) {
  const pathname = usePathname();

  return (
    <nav aria-label="Documentation" className="flex flex-col gap-6">
      {DOC_SECTIONS.map((section) => {
        return (
          <div key={section.slug}>
            <div className="text-rl-text3 mb-2 flex items-center gap-2 px-2 text-[0.7rem] font-bold tracking-[0.1em] uppercase">
              <DocIcon
                name={section.icon}
                size={13}
                aria-hidden
                className="text-rl-accent"
              />
              {section.title}
            </div>
            <ul className="flex flex-col gap-0.5">
              {section.pages.map((page) => {
                const href = `${DOCS_BASE}/${section.slug}/${page.slug}`;
                const active = pathname === href;
                return (
                  <li key={page.slug}>
                    <Link
                      href={href}
                      onClick={onNavigate}
                      aria-current={active ? "page" : undefined}
                      className={cn(
                        "block rounded-md px-3 py-1.5 text-[0.85rem] transition-colors",
                        active
                          ? "bg-rl-surface text-rl-text font-semibold"
                          : "text-rl-text2 hover:text-rl-text hover:bg-rl-bg3",
                      )}
                    >
                      {page.title}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </nav>
  );
}
